import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  circleBorder: {
    display: "flex",
    height: "16px",
    width: "16px",
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: "50%",
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center"
  },
  rectBorder: {
    display: "flex",
    height: "16px",
    width: "16px",
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: 0,
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center"
  },
  diamondBorder: {
    display: "flex",
    height: "13px",
    width: "13px",
    marginLeft: "2px",
    border: `1px solid ${theme.palette.common.black}`,
    borderRadius: 0,
    alignItems: "center",
    alignContent: "center",
    justifyContent: "center",
    transform: "rotate(45deg)",
    "& > span": {
      transform: "rotate(-45deg)"
    }
  },
  dot: {
    width: 2,
    height: 2,
    borderRadius: "50%",
    margin: 3,
    display: "block",
    background: theme.palette.common.black
  }
}));
